import * as React from 'react';
import { Button, Spinner, Row, Col, Collapse } from 'reactstrap';

export function GenericActionTile(props: {
    actionType: string;
    entityName: string,
    entityCode: string,
    afrYear: number,
    tileTitle: string;
    tileDescription: string;
    icon: string;
    isEnabled: boolean;
    isLoading: boolean | null;
    isForPublicReports?: boolean | null;
    clickAction: (atype: string, ename: string, ecode: string, aYear: number) => void
}) {


    const normalRender = (<div className="my-3">
        <div hidden={((props.isLoading != null && props.isLoading == false) || props.isLoading == null)}>
            <Spinner children={''} style={{ width: '1rem', height: '1rem', marginRight: '1em' }}
                type="grow" color="warning"
                hidden={((props.isLoading != null && props.isLoading == false) || props.isLoading == null)} />
            {props.tileDescription}
        </div>
        <div hidden={(props.isLoading != null && props.isLoading == true)}>
            <Button className="mr-3 btn btn-success" disabled={!props.isEnabled}
                onClick={() => props.clickAction(props.actionType, props.entityName, props.entityCode, props.afrYear)}
            >
                <i className={props.icon}></i>
            </Button>
            {props.tileDescription}
        </div>
    </div>);

    const publicReportsRender = (<React.Fragment>
        <Collapse isOpen={!((props.isLoading != null && props.isLoading == false) || props.isLoading == null)}>
            <Spinner children={''} style={{ width: '1rem', height: '1rem', marginRight: '1em' }}
                type="grow" color="warning"
                hidden={((props.isLoading != null && props.isLoading == false) || props.isLoading == null)} />
            {props.tileDescription}
        </Collapse>
        <Collapse isOpen={!(props.isLoading != null && props.isLoading == true)}>
            <br />
            <Row>
                <Col md="2">
                    <Button className="btn btn-success" disabled={!props.isEnabled}
                        onClick={() => props.clickAction(props.actionType, props.entityName, props.entityCode, props.afrYear)}
                    >
                        <i className={props.icon}></i>
                    </Button>
                </Col>
                <Col md="9">
                    {props.tileDescription}
                </Col>
            </Row>

        </Collapse>
    </React.Fragment>);

    return (
        !props.isForPublicReports ? normalRender : publicReportsRender
    );
}